import HistoryItemComponent from '@components/ehss/history/historyItem/body/HistoryItemComponent';
import AuditHistoryItemHeaderComponent from '@components/ehss/history/historyItem/header/AuditHistoryItemHeaderComponent';
import HistoryItemExtraInfo from '@components/ehss/history/historyItem/header/HistoryItemExtraInfoComponent';
import WorkflowItemComponent from '@components/ehss/workflows/ehssWorkflowItem/WorkflowItemComponent';
import { AuditPersonType } from '@interfaces/audit-person-type';
import Ticket from '@interfaces/ehss/ticket';
import TicketEHSS from '@interfaces/ehss/ticket-inner';
import TicketGroup from '@interfaces/ehss/ticketGroup';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Card, Col, Divider, Row } from 'antd';
import moment from 'moment';
import * as React from 'react';
import styled from 'styled-components';

interface IProp {
  data: Ticket[];
  reloadTicketGroupsClick?: any;
  showSeeMoreBtn?: boolean;
  onLoadMoreTickets?: Function
  refreshDataEvent?: any
  auditPersonType?: AuditPersonType;
  loadingData: boolean;
}

type StateType = {
  curTicket?: Ticket,
  loadingMore: boolean,
  ticketData?: Ticket,
  ticketsWorflowData?: Ticket[];
  auditItems: TicketEHSS[],
};

class AuditHistoryComponent extends React.Component<IProp, StateType> {

  state = {
    curTicket: undefined,
    ticketData: undefined,
    loadingMore: false,
    ticketsWorflowData: [],
    auditItems: [],
  };

  constructor(props: any) {
    super(props);
    // this.extractTicketGroupInfo();
  }

  renderWorkflowItem(workflow: Ticket, i: number, curTicket: any) {
    if (workflow.ehss == undefined) {
      return;
    }

    const ticketBaseData = workflow.ehss;
    // let modifiedAt = new Date(ticketGroup.modifiedAt);
    let startAt = new Date(workflow.startAt); // TODO change to ticket date

    let classNameToItem = "goepik-gray-hover";

    if (curTicket != undefined && curTicket.id != undefined) {
      if (workflow.id == curTicket.id) {
        classNameToItem += " " + "goepik-ticket-active";
      }
    }
    return (
      <Row key={i} onClick={() => this.onTicketItemClicked(workflow)} className={classNameToItem}>
        <Col sm={24} md={24} xl={24}>
          <WorkflowItemComponent
            auditorName={ticketBaseData.auditor.name}
            auditedName={ticketBaseData.audited !== null ? ticketBaseData.audited.name : ticketBaseData.auditedExternal.name}
            auditWithTitle={ticketBaseData.process.name}
            status={workflow.status}
            auditPersonType={this.props.auditPersonType}
            // statusLabel={"ticketBaseData.statusLabel"}
            date={moment(startAt).format(I18n.l('common.dateTimeFormat'))}
          />
        </Col>
      </Row>
    )
  }

  // extractTicketGroupInfo = async () => {
  //     let ticketsEhss: TicketEHSS[] = [];

  //     this.props.data.map((ticket: Ticket) => {
  //         ticketsEhss.push(ticketGroup.tickets[0].ehss);
  //     })

  //     this.setState({
  //         auditItems: ticketsEhss
  //     });
  // }

  getEhssDataFromGroup = (ticketGroup: TicketGroup) => {
    // if(ticketGroup.tickets.length > 0)
    //     if(!!ticketGroup.tickets[0].ehss)
    return ticketGroup.tickets[0];
  }

  getWorkflowTicketsFromGroup = (ticketGroup: TicketGroup) => {
    let nextWorkflowItems: Ticket[] = [];
    if (ticketGroup.tickets.length > 0) {
      for (let i = 0; i < ticketGroup.tickets.length; i++) {
        nextWorkflowItems.push(ticketGroup.tickets[i]);
      }
    }
    return nextWorkflowItems;
  }

  onTicketItemClicked = async (ticket: Ticket) => {
    // const nextTicketGroupData: Ticket = this.getEhssDataFromGroup(ticketGroup);
    // const nextWorkflowItems: Ticket[] = this.getWorkflowTicketsFromGroup(ticketGroup);
    this.setState({
      curTicket: ticket,
      // ticketData: nextTicketGroupData,
      // ticketsWorflowData: nextWorkflowItems,
    });
    document.getElementById('ticketContentCard').scrollIntoView();
  }

  onLoadMoreClicked(loadMoreEvent: any) {
    this.startLoadingMore();

    loadMoreEvent();

    window.setTimeout(() => this.stopLoadingMore(), 2000);
  }

  startLoadingMore() {
    this.setState({
      loadingMore: true
    });
  }

  stopLoadingMore() {
    this.setState({
      loadingMore: false
    });
  }

  render(): JSX.Element {
    const {
      showSeeMoreBtn,
      data,
      loadingData
    } = this.props;

    const {
      curTicket,
    } = this.state;

    return (
      <Wrapper>
        <Row id="ticketContentCard" className="goepik-component-padding">
          <Col sm={24} md={24} xl={24}>
            <Divider />

            <h2 className="title2">{I18n.l('history.audits.titles.auditsHistory')}</h2>
            <Button
              className="updateHistoryBtn"
              size="large"
              onClick={this.props.reloadTicketGroupsClick}
              loading={loadingData}
            >
              {I18n.l("history.audits.titles.updateHistory")}
            </Button>

            {this.props.loadingData && (
              <Row className="goepik-component-padding">
                <h2>{I18n.l('common.loadingTable')}</h2>
              </Row>
            )}

            {(data !== undefined) && (
              <div>
                {!this.props.loadingData && (data.length > 0) &&
                  (

                    <Row className="goepik-component-padding">
                      <Col sm={24} md={8} xl={8}>
                        <Row>
                          <Col sm={24} md={24} xl={24}>
                            <AuditHistoryCentralize>
                              <GoEpikCard  className="center">
                                <Card>
                                  {(data != undefined) && data.map((data: Ticket, i: number) => {
                                    return (
                                      <div key={i}>
                                        {this.renderWorkflowItem(data, i, curTicket)}
                                      </div>
                                    )
                                  })}
                                  {(showSeeMoreBtn &&
                                    <Row className="goepik-component-padding">
                                      <Col sm={24} md={24} xl={24} className="goepik-see-more">
                                        <Button
                                          className="see-more-btn"
                                          type="primary"
                                          size='large'
                                          ghost
                                          onClick={() => this.onLoadMoreClicked(this.props.onLoadMoreTickets)}
                                          loading={this.state.loadingMore}>
                                          {I18n.l('common.seeMore')}
                                        </Button>
                                      </Col>
                                    </Row>
                                  )}
                                </Card>
                              </GoEpikCard>
                            </AuditHistoryCentralize>
                          </Col>
                        </Row>
                      </Col>

                      {(curTicket != undefined &&
                         <HistoryWrapper>
                          <Col className="audit-history-format" xs={24} sm={24} md={24} lg={12} xl={10}>
                              <AuditHistoryItemHeaderComponent
                                auditWithTitle={curTicket.ehss.process.name}
                                auditPersonName={(this.props.auditPersonType == AuditPersonType.AUDITOR
                                  ? curTicket.ehss.audited !== null ? curTicket.ehss.audited.name : curTicket.ehss.auditedExternal.name
                                  : curTicket.ehss.auditor.name)}
                              />
                              {curTicket.info && (
                                <Row className="goepik-component-padding">
                                  <Row className="goepik-component-padding see-more-y-position-ajuster">
                                    <HistoryItemExtraInfo
                                      info={curTicket.info}
                                    />
                                  </Row>
                                </Row>
                              )}
                              <div className="goepik-component-padding">
                                <HistoryItemComponent
                                  registers={curTicket.registers}
                                  ticketStatus={curTicket.status}
                                  ticketStatusLabel={curTicket.statusLabel}
                                  workflow={curTicket.workflow}
                                />
                              </div>

                            </Col>
                          </HistoryWrapper>
                      )}
                    </Row>
                  )
                }
              </div>
            )
            }
            {
              (data === undefined || data.length === 0) && loadingData == false &&
              <Row className="goepik-component-padding">
                <Row>
                  <Col sm={24} md={24} xl={24}>
                    <h2 style={{ fontSize: '17px' }} className={'goepik-text-lightGray-bold'} >{I18n.l('titles.noDataToShow')}</h2>
                  </Col>
                </Row>

              </Row>
            }
          </Col>
        </Row>
      </Wrapper>
    );
  }
};

const Wrapper = styled.div`
    .title2{
        font-size:20px;
        font-weight:bold;
    };
    .updateHistoryBtn{
        font-weight: bold;
        text-transform: uppercase;
        margin-left:6px;
        min-width:120px;
        border-color: #1890ff;
        color: #1890ff;
    };

`;

const GoEpikCard = styled.div`
    box-shadow: 1px 1px 20px ${Theme.standard.lightGray || '#e0e0e0'};
    max-width: 320px;
    min-width: 260px;
    height : 500px;
    overflow: auto;  
    .goepik-gray-hover:hover {
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
        cursor:pointer;
    }
    .goepik-workflow-title {
        font-weight: 700;
    }
    
    .goepik-ticket-active{
        background-color: ${Theme.standard.lightGray2 || '#f3f3f3'};
    }

    .ant-card-body{
        padding-left: 0!important;
        padding-right: 0!important;
    }

    .goepik-see-more{
        text-align: center;
        padding-bottom: 24px;
    }

    
`;

const HistoryWrapper = styled.div`
  
    .audit-history-format{
  margin-left: 120px;


  @media (max-width: 1017px) {
    width: 100% !important;
    margin-left: -20px !important;
    margin-top: 20px;

    
  }
}

`;

const AuditHistoryCentralize = styled.div`
.center {
  @media (max-width: 1018px) and (min-width:767px){
    margin-left: 80%;
  }
  @media (max-width: 766px){
    margin-left: -20px !important;
  }
}
`


export default AuditHistoryComponent;
